import { customAlphabet } from 'nanoid';
import type { Tagged } from 'type-fest';
import { InvalidDomainIdError } from '../invalidDomainIdError';

const IDに利用される文字 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const _generator = customAlphabet(IDに利用される文字);

export type UniqueId = Tagged<string, 'SequentialId'>;
export namespace UniqueId {
  export const GetFactory = (length: number) => {
    const generator = () => _generator(length);

    return {
      generate(): UniqueId {
        return generator() as UniqueId;
      },

      FromString(id: string): UniqueId {
        if (!new RegExp(`^[0-9A-Za-z]{${length}}$`).test(id)) {
          throw new InvalidDomainIdError();
        }
        return id as UniqueId;
      },
    };
  };
}
